<template>
  <div class="page-content" style="margin: 0px; width: 100%">
    <v-container fluid v-if="is_self_route">
      <v-row class="justify-center  ">
        <v-col class="justify-center  " cols="10">
          <v-row class="justify-center">
            <v-col :key="`card_${index}`" cols="12" md="12" v-for="(item, index) in massRouter" xl="12">
              <v-card class="ma-3 justify-center" hover>
                <v-img
                    :src=imgCart
                    height="200px"
                >
                  <router-link :to="{name: item.router}" style="text-decoration: none">
                    <div class="adminCart white--text">{{ item.title }}</div>
                  </router-link>
                </v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import {getInstMenu, getInstNameByRouterName} from "@/helper/instances";
import names from "@/modules/recording/routers/names";
import imgCart from "@/assets/cart.png"
import {isAuthenticated} from "@/helper";


export default {
  name: "AdminMenu",
  components: {},
  data: function () {
    return {
      imgCart: imgCart,
      massRouter: [],
      names: names

    }
  },
  computed: {
    is_self_route: function () {
      return this.$route.name === names.ADMIN._BASE
    },
  },
  created() {
    this.$store.commit('leftmenu/selectInstance', getInstNameByRouterName(names.ADMIN._BASE));
    this.$store.commit('leftmenu/replaceItems', this.getLeftMenu());
    if (isAuthenticated() || this.$route.name === names.ADMIN._BASE) {
      this.$store.commit('leftmenu/replaceInstances', getInstMenu());
      this.$store.commit('leftmenu/enableLeftMenu');
      // this.$store.commit('leftmenu/hide');
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.commit('leftmenu/selectInstance', getInstNameByRouterName(names.ADMIN._BASE));
    this.$store.commit('leftmenu/replaceItems', this.getLeftMenu());
    next()
  },
  methods: {
    getLeftMenu() {
      let menu = []
      menu.push({title: 'Главная', icon: 'view_quilt', router: names.ADMIN._BASE, name: names.ADMIN._BASE,})
      menu.push({title: 'События', icon: 'grading', router: names.ADMIN.EVENTS, name: names.ADMIN.EVENTS,})
      menu.push({title: 'Письма', icon: 'mail', router: names.ADMIN.EMAILS, name: names.ADMIN.EMAILS,})
      menu.push({
        title: 'Назначение администратора',
        icon: 'add_moderator',
        router: names.ADMIN.PERMISSION,
        name: names.ADMIN.PERMISSION,
      })
      this.massRouter = menu.slice(1)

      return menu
    }
  },
}
</script>

<style scoped>

#footer-pay {
  display: none !important;
}

.adminCart {
  height: 200px;
  text-align: center;
  line-height: 200px;
  font-size: 28px;
}
</style>
